$('.slider_detail').slick({
  dots: false,
  speed: 300,
  infinite: false,
  slidesToShow: 1,
  draggable:false,
  arrows:true,
  adaptiveHeight: true,
   prevArrow: `<div class="slick-prev"><svg width="14px" height="14px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path>
        </svg></div>`,
    nextArrow: `<div class="slick-next"><svg fill="currentColor" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg></div>`
});

$(document).ready(function(){
  $(".tab__title").click(function(){
   var active_all = document.querySelectorAll(".active");
    var slideIndex = $(this).data("index");
    $('.slider_detail').slick('slickGoTo', parseInt(slideIndex), false);
    $(this).addClass("active");
    $(active_all[0]).removeClass("active")
  });

  $('.slider_detail .slick-arrow').click(function(){
    var sliderActiveId = $(this).siblings('.slick-list').find('.slick-active').attr('data-slick-index');
     setTimeout(function() {
       
        $('.tab__content').find('.tab__title[data-index="'+ sliderActiveId +'"]').addClass('active');
         $('.tab__title[data-index="'+ sliderActiveId +'"]').siblings().removeClass('active');
      }, 100);
      
  });
});

$('.review_section .multicolumn-list').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows:true,
  adaptiveHeight: true,
  prevArrow: `<div class="slick-prev"><svg width="14px" height="14px" fill="#88a0b7" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path>
        </svg></div>`,
  nextArrow: `<div class="slick-next"><svg fill="#88a0b7" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg></div>`,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

$(' .small_logo_slider .logo_collection ').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows:false,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000
      }
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
              infinite: true,
        autoplay: true,
        autoplaySpeed: 2000
      }
    }
    ,
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
              infinite: true,
        autoplay: true,
        autoplaySpeed: 2000
      }
    }
    ,
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 2000
      }
    }
  ]
});

$('.image_slider .logo_collection').slick({
  dots: false,
  infinite: false,
  slidesToShow: 7,
  slidesToScroll: 1,
  arrows:false,
  responsive: [
    {
      breakpoint:1400,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
      }
    }
    ,
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
    }
    ,
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
      }
    }
  ]
});
$('.collection_slider .product-grid').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000
      }
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000
      }
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        autoplay: false,
        autoplaySpeed: 2000
      }
    }
  ]
});

$( document ).ready(function() {
        $(document).on("click",".quick-add__ajax",function() {
          addToCartJS(1,$(this).data('variantid'),this);
        });
      });  
      function addToCartJS(qty,variantID,btn) {   
        var xhr = new XMLHttpRequest();
        var url = "/cart/add.js";
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var parsedState = JSON.parse(xhr.responseText);
            var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            cart.renderContents(parsedState);
            btn.classList.remove("loading");
          }
        };

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var sectionsToRender = cart.getSectionsToRender().map((section) => section.id);
        var sections_url = window.location.pathname;
        btn.classList.add("loading");
        var data = JSON.stringify({"quantity": qty, "id": variantID, "sections" : sectionsToRender, "sections_url" :sections_url });
        xhr.send(data);
      }

document.addEventListener("DOMContentLoaded", function() {
  var stickyCart = document.querySelector('.sticky-cart');
  var scrollThreshold = 500; // Adjust this value as needed
  var scrollThresholdMobile = 1150;
  var delay = 1000; // Adjust this value as needed (in milliseconds)
  var isStickyCartVisible = false;

  // Function to show the sticky cart
  function showStickyCart() {
    if (!stickyCart) return;
    stickyCart.style.display = 'block';
    isStickyCartVisible = true;
  }

  // Function to hide the sticky cart
  function hideStickyCart() {
    if (!stickyCart) return;
    stickyCart.style.display = 'none';
    isStickyCartVisible = false;
  }

  // Hide the sticky cart initially
  hideStickyCart();

  window.addEventListener('scroll', function() {
    if (window.matchMedia('(max-width: 543px)').matches) {
       // Check if user has scrolled past the scroll threshold
      if (window.scrollY > scrollThresholdMobile && !isStickyCartVisible) {
        // Show the sticky cart after the delay
        setTimeout(showStickyCart, delay);
      } else if (window.scrollY <= scrollThresholdMobile && isStickyCartVisible) {
        // Hide the sticky cart if it's visible and the user scrolls back up
        hideStickyCart();
      }
    } else {
      // Check if user has scrolled past the scroll threshold
      if (window.scrollY > scrollThreshold && !isStickyCartVisible) {
        // Show the sticky cart after the delay
        setTimeout(showStickyCart, delay);
      } else if (window.scrollY <= scrollThreshold && isStickyCartVisible) {
        // Hide the sticky cart if it's visible and the user scrolls back up
        hideStickyCart();
      }
    }
  });
});

$(document).ready(function(){
  $(document).on("click",".cart__checkout-button",function() {
    $(this).addClass('loading');
    $(this).find('.loading__spinner').removeClass('hidden');
    $(this).find('.checkout-content').addClass('hidden');

  });

  // VARIANT ON CHANGE PRICE UPDATE JS 
  $(document).on('change', '.Add-on', function() {
    var onChangedValue = $(this).val();
    var onChangedPrice = $(this).data("price");
    var onChangedComparePrice = $(this).data("compare-price");
    var onChangedExtraDiscountPrice = $(this).siblings(".variant_discount").text().trim();
    var onChangedFinalExtraDiscountPrice = parseInt(onChangedExtraDiscountPrice.match(/\d+/)?.[0] || 0);

    var finalPrice = (onChangedPrice *= onChangedValue).toFixed(2);
    var finalComparePrice = (onChangedComparePrice *= onChangedValue).toFixed(2);

    if (onChangedValue > 1) {
        var finalAmountPrice = (finalPrice - onChangedFinalExtraDiscountPrice).toFixed(2);
        $(".price .price__sale .price-item.price-item--sale").text("$" + finalAmountPrice + " USD");
    } else {
        $(".price .price__sale .price-item.price-item--sale").text("$" + finalPrice + " USD");
    }

    if ($(".price .price__sale .price-item.price-item--regular").length) {
        $(".price .price__sale .price-item.price-item--regular").text("$" + finalComparePrice + " USD");
    }

    var saveValuePrice = parseInt($(".price .price__sale .price-item.price-item--sale").text().match(/\d+/)?.[0] || 0);
    var saveValueComparePrice = parseInt($(".price .price__sale .price-item.price-item--regular").text().match(/\d+/)?.[0] || 0);

    if (saveValueComparePrice > 0) {
        var savedPercentage = (((saveValueComparePrice - saveValuePrice) * 100) / saveValueComparePrice);
        var finalSavedPercentage = savedPercentage.toFixed(0);
        $(".badge.badge--sale").text("Save " + finalSavedPercentage + "%");
    }
  });
});






$('.free_product').click(function(){
  var all_element = $('.free_product_content');
  all_element.hide ();
  var target_id = $(this).data('target');
  console.log("***************target_id" , target_id)
  var element = $("#" + target_id);
  element.show();
  document.body.classList.add('modal_open');
  console.log("***************element" , element)
});
$('.content_close').click(function(){
  var all_element = $('.free_product_content');
  all_element.hide ();
  document.body.classList.remove('modal_open');
 
});


$('.testimonial-carousel').slick({
  speed: 300,
  slidesToShow: 1,
  arrows:true,
  adaptiveHeight: true,
   prevArrow: `<div class="slick-prev"><svg width="14px" height="14px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path>
        </svg></div>`,
    nextArrow: `<div class="slick-next"><svg fill="currentColor" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg></div>`,

});

$(document).on('change', '#order_bump', function() {
  if($(this).is(':checked')){
    $('product-form input.order-bump-product').prop('disabled', false);
  }
  else{
    $('product-form input.order-bump-product').prop('disabled', true);
    
  }
});

